import GamesListHeader from './GamesListHeader';

export default GamesListHeader;
